import { gql, useQuery } from "@apollo/client";
import { PropertyFeatures, Feature } from "types/gql-types";

const QUERY = gql`
  query PropertyFeatures($propertyId: ID!) {
    property(id: $propertyId) {
      id
      features {
        id
        name
      }
    }
  }
`;

/** Check if a feature is enabled on a property */
export const usePropertyFeature = (propertyId: string, name: Feature): boolean | null => {
  const query = useQuery<PropertyFeatures>(QUERY, { variables: { propertyId } });

  if (query.loading || query.error || !query?.data?.property?.features) {
    return null;
  }

  return query.data.property.features.some((feature) => feature.name === name);
};
